import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { BloomreachBannerContainer } from '@personal-area/global/bloomreach';
import { DepositBonusPanelComponent } from '@personal-area/global/deposit-bonus';
import { LoaderModule } from '@personal-area/global/http/ui';
import { LocalizedDateModule } from '@personal-area/global/i18n';
import { BreadcrumbsComponent } from '@personal-area/global/navigation-layout';
import { PromoGuard } from '@personal-area/global/promo';
import {
  ButtonComponent,
  CardWrapperModule,
  DetailsModule,
} from '@personal-area/global/ui';

import { HomeComponent } from './home/home.component';
import { RewardsHubComponent } from './rewards-hub.component';
import { RewardsHubRoutingModule } from './rewards-hub-routing.module';

@NgModule({
  declarations: [RewardsHubComponent, HomeComponent],
  imports: [
    CommonModule,
    TranslateModule,
    LoaderModule,
    RewardsHubRoutingModule,
    LocalizedDateModule,
    ButtonComponent,
    BreadcrumbsComponent,
    CardWrapperModule,
    DetailsModule,
    BloomreachBannerContainer,
    DepositBonusPanelComponent,
  ],
  providers: [PromoGuard],
})
export class RewardsHubModule {}
